const firebaseConfig = {
    apiKey: "AIzaSyAQkm51NvA62-QEbvMWXgvu6rDauSlBz2g",
    authDomain: "organic-mart-a55b6.firebaseapp.com",
    projectId: "organic-mart-a55b6",
    storageBucket: "organic-mart-a55b6.appspot.com",
    messagingSenderId: "789836414508",
    appId: "1:789836414508:web:c215fe7cc7093cc0519b89"
  };
  export default firebaseConfig;